import parse from 'html-react-parser';

// ##### 25-01-02 Komarov: функция для помечания полей обязательными для заполнения (она добавляет звёздочку к названию поля)
export const markRequired = labelText => `${labelText}${parse('&nbsp;')}*`;
